var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiffuserSteamer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 85,
    viewBox: "0 0 57 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2888 84.3555L40.9204 83.0132C45.0257 80.7761 52.4151 77.1072 49.1309 80.3287C45.8467 83.5502 43.2011 84.3555 42.2888 84.3555Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7209 84.3555L16.0894 83.0132C11.9841 80.7761 4.59463 77.1072 7.87883 80.3287C11.163 83.5502 13.8087 84.3555 14.7209 84.3555Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5174 8.41309C12.5174 11.3547 11.1759 18.1205 10.251 21.6505C9.93893 22.8418 9.17351 25.3027 8.19465 28.4499C5.38503 37.4833 0.816938 52.1705 0.162558 58.7153C-0.539832 65.7402 1.04505 71.0702 4.70205 76.3652C6.86996 79.5041 12.961 85.1306 28.5003 84.321C44.0397 85.1306 50.1307 79.5041 52.2986 76.3652C55.9556 71.0702 57.5405 65.7402 56.8381 58.7153C56.1837 52.1705 51.6156 37.4833 48.806 28.4499C47.8271 25.3027 47.0617 22.8418 46.7496 21.6505C45.8248 18.1205 44.4833 11.3547 44.4833 8.41309H32.8148H24.1859H12.5174Z",
    fill: "url(#paint0_radial_2144_1053)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_2144_1053)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5046,
    cy: 10.1771,
    rx: 16.1497,
    ry: 4.41248,
    fill: "#B0F6FD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2144_1053)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5046,
    cy: 8.41248,
    rx: 16.1497,
    ry: 4.41248,
    fill: "#B0F6FD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2993 76.3652H34.5943C35.5691 76.3652 36.3593 77.1554 36.3593 78.1302C36.3593 79.105 35.5691 79.8952 34.5943 79.8952H29.2993V76.3652Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5943 76.3652H29.2993V79.8952H29.6518V76.7186H34.9468C35.3449 76.7186 35.7123 76.8504 36.0076 77.0728C35.6857 76.6432 35.1725 76.3652 34.5943 76.3652Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2402 76.3652H22.9453C21.9705 76.3652 21.1803 77.1554 21.1803 78.1302C21.1803 79.105 21.9705 79.8952 22.9453 79.8952H28.2402V76.3652Z",
    fill: "#F6F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9453 76.3652H28.2402V79.8952H27.8869V76.7186H22.5919C22.1946 76.7186 21.828 76.8498 21.5331 77.0714C21.8551 76.6426 22.3678 76.3652 22.9453 76.3652Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8129 65.0247C56.7983 65.0396 56.783 65.0552 56.7669 65.0715C56.5806 65.2589 56.2865 65.5294 55.8602 65.8555C55.0076 66.5076 53.6253 67.3826 51.5171 68.2596C47.3005 70.0136 40.1786 71.776 28.5837 71.776C16.9888 71.776 9.86691 70.0136 5.6503 68.2596C3.54214 67.3826 2.15982 66.5076 1.30723 65.8555C0.88089 65.5294 0.586809 65.2589 0.400521 65.0715C0.30737 64.9778 0.241146 64.9048 0.198796 64.8561C0.183772 64.8388 0.171751 64.8245 0.162598 64.8135C0.185157 65.0123 0.21005 65.2099 0.23727 65.4063C0.433813 65.5968 0.71375 65.8459 1.09277 66.1359C1.97086 66.8075 3.37995 67.6975 5.51472 68.5855C9.784 70.3614 16.9541 72.129 28.5837 72.129C40.2133 72.129 47.3834 70.3614 51.6527 68.5855C53.7875 67.6975 55.1966 66.8075 56.0746 66.1359C56.3436 65.9302 56.5626 65.745 56.7374 65.5867C56.7647 65.4004 56.7898 65.2131 56.8129 65.0247Z",
    fill: "#E4E4E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8588 64.6251C56.832 64.6534 56.8018 64.6846 56.7681 64.7185C56.5818 64.9059 56.2878 65.1764 55.8614 65.5025C55.0088 66.1546 53.6265 67.0296 51.5183 67.9066C47.3017 69.6606 40.1798 71.423 28.5849 71.423C16.99 71.423 9.86813 69.6606 5.65153 67.9066C3.54336 67.0296 2.16104 66.1546 1.30846 65.5025C0.882114 65.1764 0.588033 64.9059 0.401745 64.7185C0.308593 64.6248 0.24237 64.5518 0.200019 64.5031C0.178843 64.4787 0.163634 64.4604 0.154009 64.4485L0.143711 64.4357L0.141345 64.4326C0.141345 64.4326 0.141384 64.4327 0.124023 64.4459C0.142303 64.632 0.162599 64.8169 0.184904 65.0008C0.382923 65.197 0.679093 65.4655 1.094 65.7829C1.97208 66.4545 3.38117 67.3445 5.51595 68.2325C9.78522 70.0084 16.9553 71.776 28.5849 71.776C40.2146 71.776 47.3846 70.0084 51.6539 68.2325C53.7887 67.3445 55.1978 66.4545 56.0759 65.7829C56.3736 65.5551 56.6102 65.3525 56.7933 65.1838C56.8172 64.9986 56.839 64.8124 56.8588 64.6251Z",
    fill: "#F6F6F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.71,
    y: 12.8252,
    width: 7.05996,
    height: 1.23549,
    rx: 0.352998,
    fill: "#ACEEFF",
    stroke: "#8AECFD",
    strokeWidth: 0.176499
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_2144_1053",
    x: 5.29502,
    y: 2.23467,
    width: 46.4192,
    height: 22.9451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52998
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879167 0 0 0 0 0.989015 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2144_1053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2144_1053",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176499,
    result: "effect2_foregroundBlur_2144_1053"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2144_1053",
    x: 5.29502,
    y: 0.47002,
    width: 46.4192,
    height: 22.9451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52998
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879167 0 0 0 0 0.989015 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2144_1053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2144_1053",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2144_1053",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1226 27.828) rotate(90) scale(44.1247 46.5367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771351,
    stopColor: "#8BEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiffuserSteamer);
export default __webpack_public_path__ + "static/media/DiffuserSteamer.125f5723840bac3386243f6d9188fc1e.svg";
export { ForwardRef as ReactComponent };